import { createContext, useContext } from "react";
import { proxy, useSnapshot } from "valtio";

export interface ITableScrollableState {
    shrinkFirstColumn: boolean;
    firstColumnShrunkWidth: number;
    isShrinkAnimationEnabled: boolean;
    showScrollEndShadow: boolean;
}

export const createTableScrollableStore = () =>
    proxy<ITableScrollableState>({
        shrinkFirstColumn: false,
        firstColumnShrunkWidth: 0,
        isShrinkAnimationEnabled: true,
        showScrollEndShadow: false,
    });

export type TableScrollableStore = ReturnType<typeof createTableScrollableStore>;

const fallbackStore = createTableScrollableStore();

export const TableScrollableStoreContext = createContext<TableScrollableStore | null>(null);

export const useTableScrollableStore = (): TableScrollableStore => useContext(TableScrollableStoreContext) ?? fallbackStore;

export const useTableScrollableSnapshot = () => useSnapshot(useTableScrollableStore());
